import React, {useContext, useEffect, useState} from 'react';
import Master from '../../../Components/Layouts/Master';
import ContactModal from '../../../Components/ContactModal';
import './index.less';
import {Button, Col, Drawer, Dropdown, Form, Input, Menu, Modal, notification, Row, Table, Tooltip} from "antd";
import {
    DeleteOutlined,
    DownOutlined,
    EditOutlined,
    FilterOutlined,
    FilterTwoTone,
    QuestionCircleOutlined
} from "@ant-design/icons";
import moment from "moment";
import AjaxService from "../../../Services/AjaxService";
import {ProfileContext, useCan} from "../../../Contexts/ProfileContext";

function List(props: any) {

    let isCancelled = false;

    const {profile} = useContext(ProfileContext);
    const {can, canAny} = useCan(profile);

    let contactFilter: any = {
        filter: 'passenger',
        title: 'Passengers'
    };

    if (props.match.params && 'filter' in props.match.params && can('contacts.' + props.match.params.filter + '.view')) {
        switch (props.match.params.filter) {
            case 'operator':
                contactFilter = {
                    filter: 'operator',
                    title: 'Operators'
                };
                break;
            default:
                contactFilter = {
                    filter: 'passenger',
                    title: 'Passengers'
                };
                break;
        }
    }

    const [filterForm] = Form.useForm();

    const filterFormLayout = {
        labelCol: {span: 24},
        wrapperCol: {span: 24},
    };

    const [tableState, setTableState] = useState({
        loading: true,
        filterOpen: false,
        height: 100,
        selectedRows: [],
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            field: 'created_at',
            order: 'descend'
        },
        filterActive: false,
        filters: {
            query: ''
        },
        data: [] as any
    });

    const [viewState, setViewState] = useState({
        open: false,
        current: false as any,
        loading: false
    });

    const [formState, setFormState] = useState({
        visible: false,
        loading: false,
        current: false as any
    });

    const deleteSingle = (contact: any) => {
        if (contact.case_count) {
            return notification.error({
                message: 'Delete Contact',
                description: 'This contact cannot be deleted as it assigned to one or more cases.'
            });
        }
        if (contact.operator_count) {
            return notification.error({
                message: 'Delete Contact',
                description: 'This contact cannot be deleted as it assigned to one or more operators.'
            });
        }
        Modal.confirm({
            title: `Delete Contact`,
            icon: <QuestionCircleOutlined/>,
            content: 'Are you sure you want to delete this contact?',
            onOk() {
                AjaxService.delete(`contacts/${contact.id}`).then((result) => {
                    if (result !== false) {
                        notification.success({
                            message: 'Delete Contact',
                            description: 'The contact has been successfully deleted.'
                        });
                    }
                    setViewState({...viewState, current: false, open: false});
                    fetchData({...tableState, selectedRows: [], loading: true});
                });
            },
            onCancel() {
            },
        });
    }

    const fetchData = async (params: any = tableState) => {
        setTableState((previous: any) => {
            return {
                ...previous,
                loading: true
            }
        });

        let request: any = {};

        if ('pagination' in params && Object.keys(params.pagination).length > 0) {
            request.page = params.pagination.current;
            request.limit = params.pagination.pageSize;
        }

        if ('sorter' in params && 'field' in params.sorter) {
            request.sort = (typeof params.sorter.field === 'string' ? params.sorter.field : params.sorter.field.join('.'));
            if (params.sorter.order) {
                request.direction = (params.sorter.order === 'descend' ? 'desc' : 'asc');
            }
        }

        if ('filters' in params && Object.keys(params.filters).length > 0) {
            Object.keys(params.filters).forEach((key: any) => {
                if (params.filters[key]) {
                    request['filter_' + key] = params.filters[key];
                }
            });
        }

        request['filter_contact_type'] = contactFilter.filter;

        let response: any;
        try {
            response = await AjaxService.get(`contacts/`, request);
        } catch (e: any) {
            notification.error({
                message: 'There was an error',
                description: 'Unfortunately we could not load the required information. Please try again.'
            });
        }

        if (isCancelled) {
            return;
        }

        setTableState((previous: any) => {
            if (!('filters' in params)) {
                params.filters = previous.filters;
            }
            if (!('sorter' in params)) {
                params.sorter = previous.sorter;
            }
            if (!('pagination' in params)) {
                params.pagination = previous.pagination;
            }
            if (!('filterActive' in params)) {
                params.filterActive = previous.filterActive;
            }
            if (!response) {
                return {...previous, loading: false}
            }
            return {
                ...previous,
                ...params,
                loading: false,
                filterOpen: false,
                data: response.data,
                pagination: {
                    ...params.pagination,
                    total: response.meta.total
                }
            }
        });
    }

    const handleTableChange = (pagination: any, filters: any, sorter: any) => {
        fetchData({
            ...tableState,
            pagination,
            sorter
        });
    }

    const editContact = (contact: any) => {
        setFormState({...formState, visible: true, current: contact});
    }

    const columns = [{
        title: 'Name',
        key: 'name',
        dataIndex: 'name',
        render: (text: any, row: any) => {
            return <span className="clickable" onClick={() => editContact(row)}>{row.first_name} {row.last_name}</span>;
        },
        sorter: true
    }, {
        title: 'Email',
        key: 'email',
        dataIndex: 'email',
        sorter: true
    }, {
        title: 'Telephone',
        key: 'telephone',
        dataIndex: 'telephone',
        sorter: true
    }, {
        title: 'Created',
        dataIndex: 'created_at',
        sorter: true,
        render: (text: any, record: any, index: any) => moment(text).format('DD/MM/YYYY HH:mm')
    }, (canAny(['contacts.edit', 'contacts.delete']) ? {
        title: '',
        key: 'actions',
        align: 'right' as 'right',
        render: (text: any, row: any) => <Dropdown overlay={contactMenu(row)} placement="bottomRight">
            <Button icon={<DownOutlined/>}/>
        </Dropdown>
    } : null)];

    const contactMenu = (row: any, viewing: any = false) => (
        <Menu>
            {can('contacts.edit') && (
                <Menu.Item key="edit" onClick={() => editContact(row)} icon={<EditOutlined/>}>Edit</Menu.Item>
            )}
            {row.id !== 0 && can('contacts.delete') && (
                <Menu.Item key="delete" onClick={() => deleteSingle(row)} icon={<DeleteOutlined/>}>Delete</Menu.Item>
            )}
        </Menu>
    );

    const onFilter = (values: any) => {
        fetchData({
            ...tableState,
            filters: {...values},
            pagination: {
                ...tableState.pagination,
                current: 1
            },
            filterActive: true
        });
    }

    const onClearFilter = () => {
        filterForm.resetFields();
        fetchData({
            ...tableState,
            filterActive: false,
            filters: {
                query: ''
            }
        });
    }

    const addContact = () => {
        setFormState({...formState, visible: true, current: false});
    }

    const contactChanged = (add: any, contact: any) => {
        fetchData();
        if (add) {
            notification.success({
                message: 'Add Contact',
                description: `The contact was successfully created.`
            });
        } else {
            notification.success({
                message: 'Edit Contact',
                description: `The contact was successfully modified.`
            });
        }
    }

    const resizeTable = () => {
        let wrappers = document.getElementsByClassName('ant-table-wrapper');
        Array.from(wrappers).forEach((wrapper: any) => {
            let newHeight = wrapper.parentNode.clientHeight - 180;
            if (tableState.height !== newHeight) {
                setTableState((previous: any) => {
                    return {...previous, height: newHeight}
                });
            }
        });
    }

    useEffect(() => {
        resizeTable();
    });

    useEffect(() => {
        // eslint-disable-next-line
        isCancelled = false;
        fetchData();
        window.addEventListener('resize', resizeTable);
        return () => {
            isCancelled = true;
            window.removeEventListener('resize', resizeTable);
        };
    }, [props]);

    return (
        <Master className={`ContactsList`}>
            <Drawer
                title="Filter Contacts"
                visible={tableState.filterOpen}
                closable={true}
                destroyOnClose
                forceRender
                onClose={() => setTableState({...tableState, filterOpen: false})}
                footer={
                    <div
                        style={{
                            display: 'flex',
                        }}
                    >
                        <Button onClick={() => onClearFilter()} type="text" danger={true}>
                            Clear Filter
                        </Button>
                        <Button onClick={() => setTableState({...tableState, filterOpen: false})}
                                style={{marginRight: 8, marginLeft: 'auto'}}>
                            Close
                        </Button>
                        <Button onClick={() => filterForm.submit()} type="primary">
                            Apply Filters
                        </Button>
                    </div>
                }
            >
                <Form
                    {...filterFormLayout}
                    form={filterForm}
                    onFinish={onFilter}
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label="Search"
                                name="query"
                            >
                                <Input placeholder="Search" value={tableState.filters.query}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Drawer>
            <div className="CaseTableActions">
                <span className="CaseTableTitle">Contacts - {contactFilter.title}</span>
                {/* <span className="CaseTableTitle">Address Book</span> */}
                {can('contacts.add') && (
                    <Button style={{marginLeft: '.5rem'}} onClick={() => addContact()}>Add Contact</Button>
                )}
                <Tooltip title="Filter Contacts" placement="left">
                    <Button
                        icon={(tableState.filterActive ? <FilterTwoTone twoToneColor="#52c41a"/> : <FilterOutlined/>)}
                        onClick={() => setTableState({...tableState, filterOpen: true})}
                        style={{marginLeft: '.5rem'}}
                    />
                </Tooltip>
            </div>
            <Table
                className="ContactTable"
                columns={columns.filter(c => c != null) as any}
                dataSource={tableState.data}
                loading={tableState.loading}
                rowKey="id"
                onChange={handleTableChange}
                pagination={tableState.pagination}
                scroll={{y: tableState.height}}
            />
            {can('contacts.add') && (
                <Button className={tableState.data.length ? 'PaginationButton' : 'mt-15'} onClick={() => addContact()}>Add
                    Contact</Button>
            )}
            {can('contacts.add') && formState.visible && (
                <ContactModal onAdd={(contact: any) => contactChanged(true, contact)}
                              onEdit={(contact: any) => contactChanged(false, contact)} current={formState.current}
                              contactType={contactFilter.filter}
                              onClose={() => setFormState({...formState, visible: false})}/>
            )}
        </Master>
    );
}

export default List;